/**
 * ThermostatSetMode Style02 - Compact icon row
 */
import type { TraitControlProps } from './types'

const MODES = [
  { id: 'cool', label: 'Cool', icon: 'ac_unit' },
  { id: 'heat', label: 'Heat', icon: 'local_fire_department' },
  { id: 'dry', label: 'Dry', icon: 'water_drop' },
  { id: 'fan-only', label: 'Fan', icon: 'air' },
  { id: 'auto', label: 'Auto', icon: 'autorenew' },
] as const

export function ThermostatSetModeStyle02({
  state,
  onCommand,
  disabled = false,
}: TraitControlProps) {
  const raw = (state?.thermostatMode ?? state?.mode ?? state?.currentModeSettings) as string | undefined
  const current = typeof raw === 'string' ? raw.toLowerCase() : 'cool'
  const normalized = MODES.some((m) => m.id === current) ? current : 'cool'

  return (
    <div className="smart-home-automation-field">
      <label>Mode</label>
      <div className="smart-home-automation-command-row">
        {MODES.map((m) => (
          <button
            key={m.id}
            type="button"
            className={`smart-home-automation-command-btn glass ${normalized === m.id ? 'active' : ''}`}
            onClick={() => !disabled && onCommand('setMode', { mode: m.id })}
            disabled={disabled}
            title={m.label}
          >
            <span className="material-symbols-outlined">{m.icon}</span>
          </button>
        ))}
      </div>
    </div>
  )
}
